import Framework from 'framework';
import partner from 'components/partner';
import { proxyToUrlStore } from './proxyToEnterpriseFramework';

const UrlStore = {
	name: 'UrlStore',
	getInitialData: () => {
		const efUrlStoreData = proxyToUrlStore('getInitialData')();
		const { currentUrl, globalPageDrivers, initialized } = efUrlStoreData;
		// enterprise-framework urlStore stores `window.lt.globalPageDrivers`
		// but legacy callers expect `window.lt.globalPageDrivers.global`
		// TODO: fix legacy callers to do their own `.global`
		return {
			currentUrl,
			globalPageDrivers: globalPageDrivers.global,
			initialized
		};
	},
	initialize: proxyToUrlStore('initialize'),
	listen: proxyToUrlStore('listen'),
	urlUpdated: proxyToUrlStore('urlUpdated'),
	updateUrl: proxyToUrlStore('updateUrl'),
	bindPartnerUrls: () => {
		partner(); // TODO: verify window.ef.urlService.bindPartnerUrls() works and use it instead
	}
};
Framework.registerStore(UrlStore.name, UrlStore);

export default UrlStore;
